import layout from '@/layout'

export default {
  path: '/bossWork',
  component: layout,
  redirect: '/bossWork/person/performance',
  name: 'BossWorkPersonPerformance',
  meta: {
    title: 'bossWork',
    icon: 'el-icon-document'
  },
  children: [
    {
      path: '/bossWork/person/performance',
      name: 'BossWorkPersonPerformance',
      component: () => import('@/views/person/performance/index'),
      meta: {
        title: 'BossWorkPersonPerformance',
        icon: 'el-icon-document'
      }
    }
  ]
}
